/** Unicode-safe Base64 encode/decode for API text and HTML payloads. */
export const base64Encode = (str = "") =>
  btoa(
    new TextEncoder()
      .encode(String(str ?? ""))
      .reduce((data, byte) => data + String.fromCharCode(byte), ""),
  );

export const base64Decode = (str = "") => {
  const binary = atob(String(str ?? "").trim());
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

const looksLikeBase64 = (value = "") => {
  const raw = String(value ?? "").trim();
  if (!raw || raw.length % 4 !== 0) return false;
  return /^[A-Za-z0-9+/]+={0,2}$/.test(raw);
};

export const looksLikeHtmlContent = (value = "") =>
  /^\s*</.test(String(value ?? "").trim());

export const decodePlainTextFromApi = (value = "") => {
  const raw = String(value ?? "").trim();
  if (!raw || !looksLikeBase64(raw)) return raw;

  try {
    return base64Decode(raw);
  } catch {
    return raw;
  }
};

/**
 * Decode a rich-text field from the API.
 * Supports Base64-encoded HTML (current), legacy raw HTML, and legacy full-document HTML.
 */
export const decodeRichTextHtmlFromApi = (value = "", unwrapDocument = (html) => html) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  if (looksLikeHtmlContent(raw)) {
    return unwrapDocument(raw);
  }

  if (!looksLikeBase64(raw)) {
    return raw;
  }

  try {
    return unwrapDocument(base64Decode(raw));
  } catch {
    return raw;
  }
};

/** Encode text once before API submission. */
export const encodeTextForApi = (value = "") => {
  const text = String(value ?? "").trim();
  if (!text) return "";
  return base64Encode(text);
};

/** @deprecated Use encodeTextForApi */
export const encodeRichTextHtmlForApi = encodeTextForApi;
